import { memo } from 'react';
import OutlineText from './OutlineText';
import mutedIcon from "images/Host/lobby_muted.png";
import unmutedIcon from "images/Host/lobby_unmuted.png";
import fullscreenIcon from "images/Host/lobby_fullscreen.png";
import helpIcon from "images/Host/lobby_help.png";
import QRCode from 'qrcode.react';

const RoomDetails = memo(function RoomDetails({ styles, url, displayUrl, muted, roomId, fullscreenAvailable, onToggleMute, onToggleFullScreen, onToggleMenu, hideButtons, isMirror }) {
    return (
        <div className={styles.roomCode}>
            <OutlineText styles={styles} text={displayUrl} />
            <div className={styles.topRow}>
                <div className={styles.qrCodeBox}>
                    <QRCode
                        className={styles.qrCode}
                        value={`${url}/play/?qrCode=${roomId}`}
                        bgColor="rgba(0,0,0,0)"
                    />
                </div>
                {
                    !hideButtons &&
                    <div className={styles.iconsBox}>
                        <div className={styles.iconButton} onClick={() => onToggleMute()}>
                            <img src={muted ? mutedIcon : unmutedIcon} className={styles.icon} alt="mute" />
                        </div>
                        {fullscreenAvailable && (
                            <div className={styles.iconButton} onClick={() => onToggleFullScreen()}>
                                <img src={fullscreenIcon} className={styles.icon} alt="fullscreen" />
                            </div>
                        )}
                        <div className={styles.iconButton} onClick={() => onToggleMenu()}>
                            <img src={helpIcon} className={styles.icon} alt="help" />
                        </div>
                    </div>
                }
            </div>
            <div className={styles.codeRow}>
                <span className={styles.codeLabel}>CODE</span>
                <span className={styles.codeValue}>{roomId}</span>
            </div>
            {isMirror && <div className={styles.mirrorBadge}>CONNECT</div>}
        </div>
    );
});

export default RoomDetails;
